export default {
	getHeaders() {
        return {
            field:  [
                {
                    field: "created_at",
                    title: 'creationDate',
                    align: 'center',
                    width: '10%'
                },
                {
                    field: "user_manager_id",
                    title: 'managers',
                    align: 'center',
                    width: '15%'
                },
                {
                    field: "order_id",
                    title: 'order',
                    align: 'center',
                    width: '5%'
                },
                {
                    field: "chat",
                    title: 'chat',
                    align: 'center',
                    width: '5%'
                },
                {
                    field: "site",
                    title: 'site',
                    align: 'center',
                    width: '10%'
                },
                {
                    field: "info",
                    title: 'info',
                    align: 'center',
                    width: '65%'
                },
            ],
        }
    
	}
};
